import React from "react";
import FernGroup from "./FernGroup.jsx";

export default function FernSystem({ openAmount = 1, windStrength = 0 }) {
  return (
    <group>
      <FernGroup openAmount={openAmount} windStrength={windStrength}/>
    </group>
  );
}